export default "/static/tecan_infinite_tiny.png";